const projects_list = [

    {
        id: 1,
        name: "NextHome",
        description: "NextHome is browser extension to return to the original search results page in the current tab with just a single click.",
        topics: ["browser-extension", "javascript"],
        html_url: "https://github.com/Dinesh563/NextHome",
        homepage: null
    },
    {
        id: 2,
        name: "GeoTalk",
        description: "A simple web server where users can share messages without needing to exchange contact information — no need to note down a stranger’s phone number",
        topics: ["golang", "redis", "reactjs"],
        html_url: "https://github.com/Dinesh563/GeoTalk",
        homepage: "https://geotalk.up.railway.app/"
    },
    {
        id: 3,
        name: "SockStorm",
        description: "A simple go service that rigorously tests a websocket connection",
        topics: ["golang", "testing"],
        html_url: "https://github.com/Dinesh563/sockstorm",
        homepage: null
    }
]

export default projects_list